export const rawColors = "rjztx87";
export const root = "r1euql24";
export const frame = "fdgpyyo";
export const frame_light = "f2y8cj5";
export const frame_dark = "fb2rp3d";

require("./style.linaria.module.css!=!../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./style.ts");